import { IWorkflowFormMutations } from './mutations.types';
import {
  IDepartmentData,
  IWorkflowFormSubmissionChecklistData,
  IWorkflowFormSubmissionCommentData,
  IWorkflowFormSubmissionData,
  IWorkflowTransitionData,
  IWorkflowTransitionLogData,
  IUserData
} from '@/models';
import { IWorkflowFormState } from '../workflow-form.types';
import { IWorkflowFormPaginatedListData } from '@/services';

export const mutations: IWorkflowFormMutations = {
  SET_COUNT(state: IWorkflowFormState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IWorkflowFormState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IWorkflowFormState): void {
    state.count -= 1;
  },

  SET_WORKFLOW_FORM_SUBMISSIONS(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionData[]
  ): void {
    state.workflowFormSubmissions = payload;
  },

  ADD_WORKFLOW_FORM_SUBMISSION(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionData
  ): void {
    state.workflowFormSubmissions.unshift(payload);
  },

  UPDATE_WORKFLOW_FORM_SUBMISSION(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionData
  ): void {
    const index = state.workflowFormSubmissions.findIndex(
      (submission: IWorkflowFormSubmissionData) => submission.id === payload.id
    );

    state.workflowFormSubmissions.splice(index, 1, payload);
  },

  REMOVE_WORKFLOW_FORM_SUBMISSION(
    state: IWorkflowFormState,
    payload: number
  ): void {
    const index = state.workflowFormSubmissions.findIndex(
      (submission: IWorkflowFormSubmissionData) => submission.id === payload
    );

    state.workflowFormSubmissions.splice(index, 1);
  },

  SET_WORKFLOW_FORM_SUBMISSION_TRANSITIONS(
    state: IWorkflowFormState,
    payload: IWorkflowTransitionData[]
  ): void {
    state.workflowFormSubmissionTransitions = payload;
  },

  SET_WORKFLOW_FORM_SUBMISSION_AVAILABLE_ASSIGNEES(
    state: IWorkflowFormState,
    payload: IUserData[]
  ): void {
    state.workflowFormSubmissionAvailableAssignees = payload;
  },

  SET_LAST_PROMISE(
    state: IWorkflowFormState,
    payload: Promise<IWorkflowFormPaginatedListData> | null
  ): void {
    state.lastPromise = payload;
  },

  SET_CHECKLIST_ASSIGNEE_OPTIONS(
    state: IWorkflowFormState,
    payload: IUserData[]
  ): void {
    state.checklistAssigneeOptions = payload;
  },

  //templates
  SET_WORKFLOW_FORM_CHECKLISTS(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionChecklistData[]
  ): void {
    state.workflowFormChecklists = payload;
  },

  ADD_WORKFLOW_FORM_CHECKLIST(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionChecklistData
  ): void {
    state.workflowFormChecklists.push(payload);
  },

  UPDATE_WORKFLOW_FORM_CHECKLIST(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionChecklistData
  ): void {
    const index = state.workflowFormChecklists.findIndex(
      (template: IWorkflowFormSubmissionChecklistData) =>
        template.id === payload.id
    );

    state.workflowFormChecklists.splice(index, 1, payload);
  },

  SET_WORKFLOW_FORM_DEPARTMENTS(
    state: IWorkflowFormState,
    payload: IDepartmentData[]
  ): void {
    state.workflowFormDepartments = payload;
  },

  //comment
  SET_WORKFLOW_FORM_SUBMISSION_COMMENTS(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_WORKFLOW_FORM_SUBMISSION_COMMENT(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_WORKFLOW_FORM_SUBMISSION_COMMENT(
    state: IWorkflowFormState,
    payload: IWorkflowFormSubmissionCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IWorkflowFormSubmissionCommentData) => comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_WORKFLOW_FORM_SUBMISSION_COMMENT(
    state: IWorkflowFormState,
    payload: number
  ): void {
    const index = state.comments.findIndex(
      (comment: IWorkflowFormSubmissionCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_WORKFLOW_FORM_SUBMISSION_ACTIVITIES(
    state: IWorkflowFormState,
    payload: IWorkflowTransitionLogData[]
  ): void {
    state.activities = payload;
  },

  SET_WORKFLOW_FORM_MENTIONABLE_USERS(
    state: IWorkflowFormState,
    payload: IUserData[]
  ): void {
    state.mentionableUsers = payload;
  }
};
